import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.is-array.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.push.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.some.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __spreadArray, __assign } from '../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import { isArray } from 'lodash';

function findTreePath(option, target, paths) {
  if (!option) {
    return false;
  }
  paths.push(option);
  if (option.value === target) {
    return true;
  }
  if (Array.isArray(option.children)) {
    var _children = __spreadArray([], option.children, true);
    if (_children.some(function (x) {
      return findTreePath(x, target, paths);
    })) {
      return true;
    }
  }
  paths.pop();
}
function batchFindTreePath(tree, target) {
  var changed = [];
  if (!isArray(tree) || (tree === null || tree === void 0 ? void 0 : tree.length) === 0) {
    return changed;
  }
  for (var i = 0; i < tree.length; i++) {
    var x = tree[i];
    if (findTreePath(x, target, changed)) {
      break;
    }
  }
  return changed.map(function (x) {
    return {
      label: x.label,
      value: x.value
    };
  });
}
function modifyNode(updateNode, target, options) {
  if (isArray(options)) {
    return options.map(function (option) {
      if (option.value === target) {
        return updateNode;
      }
      if (isArray(option.children)) {
        return __assign(__assign({}, option), {
          children: modifyNode(updateNode, target, option.children)
        });
      }
      return option;
    });
  }
  return [];
}
function batchModifyNode(updateNode, target, sourceOptions) {
  var options = isArray(sourceOptions) ? __spreadArray([], sourceOptions, true) : [];
  return options.map(function (option) {
    if (option.value === target) {
      return updateNode;
    }
    if (isArray(option.children)) {
      return __assign(__assign({}, option), {
        children: modifyNode(updateNode, target, option.children)
      });
    }
    return option;
  });
}

export { batchFindTreePath, batchModifyNode, findTreePath, modifyNode };
